import { useRouter } from 'next/router';
import React from 'react';

import * as LocaleConstants from '../../../constants/LocaleConstants';
import { HeaderContentEntity } from '../../domain/entities/HeaderContentEntity';
import styles from '../styles/Header.module.scss';
import { getVm } from '../vm/HeaderVm';

import DownloadAppCmp from './DownloadAppCmp';
import HeaderLinksCmp from './HeaderLinksCmp';
import HeaderMobileMenuSection from './HeaderMobileMenuSection';
import LegalHeaderCmp from './LegalHeaderCmp';

interface HeaderViewCmpProps {
  data: HeaderContentEntity;
  show_download_sticky: boolean;
}

function HeaderViewCmp({
  data,
  show_download_sticky,
}: Readonly<HeaderViewCmpProps>): React.ReactElement {
  const { locale } = useRouter();
  const { company_content, links, menu_content, open_app_content } =
    getVm(data);
  const { location_icon, company_info } = company_content;
  const { refund_policy_link, terms_of_service_link } = links;

  const shouldShowLegalHeader =
    locale === LocaleConstants.bn_BD || locale === LocaleConstants.en_BD;

  return (
    <div className={styles['sticky-wrapper']}>
      {show_download_sticky ? <DownloadAppCmp data={open_app_content} /> : null}
      {shouldShowLegalHeader ? (
        <LegalHeaderCmp
          location_icon={location_icon}
          company_info={company_info}
          refund_policy_link={refund_policy_link}
          terms_of_service_link={terms_of_service_link}
        />
      ) : null}
      <div className={styles['header-wrapper']}>
        <div className={styles['header-container']}>
          <HeaderLinksCmp data={data} />
        </div>
        <HeaderMobileMenuSection menu_content={menu_content} />
      </div>
    </div>
  );
}

export default HeaderViewCmp;
